module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har anmält sitt intresse till jobbet":"has expressed an interest to the job"},"sv":{"Kandidaten":"Kandidaten","har anmält sitt intresse till jobbet":"har anmält sitt intresse till jobbet"}}')
  delete Component.options._Ctor
}
